<template>
  <a-row class="demo-detail">
    <a-breadcrumb class="a-bread-sty" separator=">">
      <a-breadcrumb-item v-for="item in breadList" :key="item.name">
        <router-link :to="{ path: item.path === '' ? '/' : item.path }">{{
          item.meta.title
        }}</router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <h2 align="center">移动工业APP</h2>

    <div class="top">
      <p>
        移动工业APP，生产计划、操作、质检、维护保养以及班组管理和设备管理等一站式个人系统门户。
      </p>
      <img src="../../assets/image/adminName.png" />
    </div>
    <div class="proj-role">
      <p class="proj-one">项目作用</p>
      <p class="proj-t">
        1）完整地表达一个或多个特定功能，解决特定的问题每一个工业APP都是可以完整地表达一个或多个特定的功能，解决特定的具体问题的工业应用程序。这是工业APP区别于一般的工具软件和工业软件的特征，工具软件和工业软件的功能通常具有普适性，可解决一大类相似的问题。
        （2）工业技术要素的载体工业APP是工业技术要素的载体，在工业APP中封装了具有特定功能和解决特定问题的流程、逻辑、数据流、经验、算法、知识、规律等工业技术要素，工业APP固化这些技术要素，每一个工业APP都是一些特定工业技术要素结合特定应用场景的集合与载体，这一特征赋予工业APP知识的属性。
        （3）工业技术要素与原宿主解耦从工业APP的定义看，工业APP是要高效重用并广泛传播的一种工业应用程序，如果工业APP承载的工业技术要素不能与原宿主解耦，高效重用和广泛传播的目标就很难达成。因此，工业APP所承载的工业技术要素必须与原宿主解耦。这里所说的原宿主可以是拥有工业技术经验、掌握规律与知识的人或由人构成的组织，也可以是隐含或潜藏着规律与特性的客观存在的某一个事物。
      </p>
    </div>

    <h2 align="center">移动工业APP</h2>
    <p class="to-p" align="center">
      精通国际主流控制系统平台，为酿造行业定制化开发工艺模版，提高生产控制系统稳定性和控制精度。
    </p>

    <div class="swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in planList"
          :key="item.id"
          @mouseover="switchItem(item)"
        >
          <img :src="item.img" />
        </div>
      </div>
    </div>

    <!-- <h2 align="center">项目亮点</h2>
    <div class="bottom-box">
      <img class="box-img" src="../../assets/image/32650.png">
      <ul class="list">
        <li>集中管控各生产线生产
          流程，减少了中间环节 </li>
        <li>报错机制，生产过程中
          的问题会有及时响应，提高生产效率。</li>
        <li>集中管控各生产线生
          产流程，减少了中间环节 </li>
        <li>报错机制，生产过程中的
          问题会有及时响应，提高生产效率。</li>
      </ul>
    </div> -->
  </a-row>
</template>

<script>
import Swiper from "../../../node_modules/swiper/swiper-bundle.js";
export default {
  mounted() {
    this.getBreadcrumb();
    var mySwiper = new Swiper(".swiper", {
      direction: "horizontal", //
      loop: true,
      breakpoints: {
        320: {
          //当屏幕宽度大于等于320
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          //当屏幕宽度大于等于768
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 1000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      disableOnInteraction: false,
    });
  },
  data() {
    return {
      planList: [
        {
          id: 1,
          img: require("../../assets/image/app1.png"),
        },
        {
          id: 2,
          img: require("../../assets/image/app2.png"),
        },
        {
          id: 3,
          img: require("../../assets/image/app3.png"),
        },
        {
          id: 4,
          img: require("../../assets/image/app4.png"),
        },
      ],

      breadName: "",
      breadList: [],
    };
  },
  methods: {
    getBreadcrumb() {
      this.breadList = [];
      this.breadName = this.$route.name;
      this.$route.matched.forEach((ele, index, arr) => {
        this.breadList.push(ele);
      });
    },
  },
};
</script>

<style lang="less">

.demo-detail {
  margin: 0 auto;
  h2 {
    margin-top: 120px;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }
  .a-bread-sty {
    width: 1440px;
    margin: 40px auto;
    font-size: 20px;
  }
  .top {
    width: 1440px;
    margin: 0 auto;
    margin-top: 140px;
    padding: 51px;
    background: linear-gradient(#f9fafe, #e7eeff);
    border-radius: 20px;
    box-shadow: 0 10px 20px #cccccc;
    display: flex;
    align-items: center;
    img {
      width: 200px;
      height: 300px;
    }
  }
  .to-p {
    margin-bottom: 40px;
  }
  .swiper {
    width: 1440px;
    border-radius: 20px;
    .swiper-slide {
      img {
        width: 100%;
        height: 200px;
      }
    }
  }
  .proj-role {
    margin: 0 auto;
    margin-top: 150px;
    width: 1440px;
    border-radius: 25px;
    padding: 50px;
    color: #ffffff;
    // background: linear-gradient(to right, #ff6600, #ff9354);
    background: url("../../assets/image/32647.png") no-repeat;
    background-size: cover;
    box-shadow: 0 10px 20px #cccccc;
    .proj-one {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
    }
    .proj-t {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }
  }
  .bottom-box {
    width: 100%;
    background: url("../../assets/image/32651.png");
    text-align: center;

    .box-img {
      width: 1440px;
      height: 529px;
    }
    .list {
      margin: 0 auto;
      width: 1440px;

      display: flex;
      justify-content: space-between;
      padding-bottom: 50px;
      li {
        width: 20%;
        &:nth-child(1),
        &:nth-child(4) {
          margin-top: -220px;
        }
        &:nth-child(2),
        &:nth-child(3) {
          margin-top: -50px;
        }
      }
    }
  }
}

@media all and (max-width: 700px) {
    .demo-detail {
      margin: 0 auto;
      padding: 0 200px;
      h2 {
        margin-top: 120px;
        font-size: 80px;
        font-family: Source Han Sans CN;
        font-weight: bold;
      }
  
      .a-bread-sty {
        width: 1440px;
        margin: 40px auto;
        font-size: 40px;
      }
  
      .top {
        width: 1440px;
        margin: 0 auto;
        margin-top: 140px;
        padding: 51px;
        background: linear-gradient(#f9fafe, #e7eeff);
        border-radius: 20px;
        box-shadow: 0 10px 20px #cccccc;
        display: flex;
        align-items: center;
  
        img {
          width: 200px;
          height: 300px;
        }
        p {
          font-size: 48px;
        }
      }
  
      .to-p {
        margin-bottom: 40px;
        font-size: 48px;
      }
  
      .swiper {
        width: 1440px;
        border-radius: 20px;
  
        .swiper-slide {
          img {
            width: 100%;
            height: 200px;
          }
        }
      }
  
      .proj-role {
        margin: 0 auto;
        margin-top: 150px;
        width: 1440px;
        border-radius: 25px;
        padding: 50px;
        color: #ffffff;
        background: url("../../assets/image/32647.png") no-repeat;
        background-size: cover;
        box-shadow: 0 10px 20px #cccccc;
  
        .proj-one {
          font-size: 80px;
          font-family: Source Han Sans CN;
          font-weight: bold;
        }
  
        .proj-t {
          font-size: 48px;
          font-family: Source Han Sans CN;
          font-weight: 400;
        }
      }
  
      .bottom-box {
        width: 100%;
        background: url("../../assets/image/32651.png");
        text-align: center;
  
        .box-img {
          width: 1440px;
          height: 529px;
        }
  
        .list {
          margin: 0 auto;
          width: 1440px;
  
          display: flex;
          justify-content: space-between;
          padding-bottom: 50px;
  
          li {
            width: 20%;
  
            &:nth-child(1),
            &:nth-child(4) {
              margin-top: -220px;
            }
  
            &:nth-child(2),
            &:nth-child(3) {
              margin-top: -50px;
            }
          }
        }
      }
    }
  }
</style>
